/*
 * @Author:
 * @LastEditTime: 2025-11-28 16:37:58
 * @Description:
 */
import { BridgeModelApi } from '@wiz-api/huizhou2-business'

const bridgeModelApi = new BridgeModelApi()

let cloudRender = null
let player = null

const setRootModelShow = async (show) => {
  const root = await cloudRender.NodeProxy.getRoot()

  await cloudRender.NodeProxy.setNodeVisible(root.dataInfo.node, show)
}

const init = async (sourceId) => {
  setRootModelShow(false)
  const [err, res] = await bridgeModelApi.getList({
    sceneId: sourceId,
    skipCount: 0, // Number |
    maxResultCount: 999, // Number |
  })
  if (!err) {
    const params = []
    res.items.forEach((item) => {
      params.push({
        code: item.code,
      })
    })
    const root = await await cloudRender.NodeProxy.getRoot()
    const codeRes = await cloudRender.NodeProxy.findNode('codes', params, root?.dataInfo?.node)
    const visibleList = []
    codeRes?.data?.forEach((resItem) => {
      visibleList.push(resItem.dataInfo.node)
    })
    await cloudRender.NodeProxy.setNodeVisible(visibleList, true)
  }
}
// 创建
const create = async (propPlayer, sourceId, propCloudRender) => {
  if (!propPlayer.Native) {
    return
  }
  cloudRender = propCloudRender
  player = propPlayer
  // 初始化,设置隐藏显示
  init(sourceId)
}

const destroy = async (propPlayer) => {
  if (!propPlayer.Native) {
    return
  }
  await setRootModelShow(true)
  cloudRender = null
  player = null
}

const hidden = async () => {}

const display = async () => {}

export default { create, destroy, hidden, display }
